import { Injectable } from '@angular/core';
import { ApiInterface } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import { MarcaDTO, MarcaResponseDTO } from '../../models/marca.model';

@Injectable({
  providedIn: 'root',
})
export class MarcaService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(url: string, data?: any): Observable<MarcaResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<MarcaResponseDTO>(patch);
  }

  getById<T>(url: string): Observable<MarcaDTO> {
    return this.apiService.read<MarcaDTO>(url);
  }

  post<T>(url: string, data: MarcaDTO): Observable<MarcaDTO> {
    return this.apiService.create<MarcaDTO>(url, data);
  }

  put<T>(url: string, data: MarcaDTO): Observable<MarcaDTO> {
    return this.apiService.update<MarcaDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
